var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.526 16.2764c0-.8158-.0661-1.6359-.2072-2.4384h-11.3188v4.621h6.4817c-.2689 1.4903-1.1332 2.8087-2.3987 3.6465v2.9984h3.867c2.2708-2.0901 3.576-5.1766 3.576-8.8275z",
    fill: "#7c6e9b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.9999 28.0008c3.2364 0 5.9658-1.0626 7.9544-2.8969l-3.867-2.9984c-1.0759.732-2.4648 1.1465-4.083 1.1465-3.1307 0-5.7851-2.1121-6.73749-4.9517h-3.99044v3.0909c2.03711 4.0522 6.18633 6.6096 10.72353 6.6096z",
    fill: "#9e90bd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.26254 18.3003c-.50266-1.4904-.50266-3.1042 0-4.5945v-3.091h-3.98604c-1.702 3.3908-1.702 7.3856 0 10.7764z",
    fill: "#afa1ce"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.9999 8.74966c1.7108-.02645 3.3643.61731 4.6033 1.79904l3.4261-3.42608c-2.1694-2.03711-5.0487-3.15709-8.0294-3.12181-4.5372 0-8.68642 2.55741-10.72353 6.61399l3.98603 3.091c.948-2.8441 3.6068-4.95614 6.7375-4.95614z",
    fill: "#8d7fac"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIconGray);
export default __webpack_public_path__ + "static/media/googleIconGray.241a25c718d163c285bd731cbd16c42b.svg";
export { ForwardRef as ReactComponent };